import React from "react";
import ChipSelector from "../ChipSelector";

export const DrawInput = ({ label, ...props }) => {
  return (
    <div className="draw__item">
      <div className="draw__item__title draw__item__title--mb-sm t--upcase t--sm">{label}</div>
      <div className="chip__well">
        <ChipSelector {...props} />
      </div>
    </div>
  );
};
